import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import Select from "react-dropdown-select";
import styles from "./Dropdown.module.scss";
import { CustomDropdownRenderer } from "./helper";

const Dropdown = (props) => {
  const {
    name,
    label,
    multi = false,
    options = [],
    className,
    onChange,
    value = "",
    placeholder = "",
    required,
    disabled,
    variant,
    iconLeft,
    onClick,
    onClose,
    valueKey = "value",
    ...otherProps
  } = props;
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropOptions, setDropOptions] = useState(options);


  useEffect(() => {
    let cp = JSON.parse(JSON.stringify(options));
    cp = cp && cp.map((el) => {
      return { ...el, value: el[valueKey] }
    })
    setDropOptions(cp);
    // eslint-disable-next-line
  }, [options])

  useEffect(() => {
    if (multi && value && dropOptions) {
      const selectedOptions = dropOptions.filter(
        (item) => value && value.includes(item[valueKey])
      );
      setSelectedOptions(selectedOptions);
    } else if (value && dropOptions) {
      const selectedOption = dropOptions.filter((item) => item[valueKey] === value);
      setSelectedOptions(selectedOption);
    } else {
      setSelectedOptions([]);
      setDropdownOpen(false);
    }
    if (value) {
      setDropdownOpen(true);
    }
    // eslint-disable-next-line
  }, [value, multi, dropOptions]);

  const handleOnChange = (name, values) => {
    setSelectedOptions(values);
    if (multi) {
      onChange && onChange({ name, value: values.map((item) => item[valueKey]) });
    } else {
      onChange &&
        onChange({ name, value: values.length ? values[0][valueKey] : "" });
    }
  };

  return (
    <div
      className={`${styles.dropdownWrapper} ${styles[variant]} dropdown`}
      style={{ opacity: disabled ? 0.6 : 1 }}
    >
      {iconLeft && <img src={iconLeft} alt="" />}
      {label && (
        <label
          style={{
            ...(dropdownOpen && { top: "-12px", left: "12px", zIndex: 1 }),
            ...((iconLeft && !dropdownOpen && { left: "40px" }) || {
              left: "15px",
            }),
            // opacity: disabled ? "0.6" : 1,
          }}
          className={`${styles.label} dropdown-label ${dropdownOpen && "dropdown-open"
            }`}
        >
          {label}
          {required && " * "}
        </label>
      )}
      <Select
        name={name}
        values={selectedOptions}
        onDropdownOpen={() => {
          setDropdownOpen(true);
          onClick && onClick();
        }}
        onDropdownClose={() => {
          !selectedOptions.length && setDropdownOpen(false);
          onClose && onClose();
        }}
        className={`${styles.dropdown} ${className} dropdown-component`}
        multi={multi}
        placeholder={placeholder}
        options={dropOptions || []}
        onChange={(values) => handleOnChange(name, values)}
        dropdownRenderer={
          multi && dropOptions && dropOptions.length && CustomDropdownRenderer
        }
        disabled={disabled}
        {...otherProps}
      />
    </div>
  );
};

Dropdown.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  multi: PropTypes.bool,
  placeholder: PropTypes.string,
  clearable: PropTypes.bool,
  options: (PropTypes.array = []),
  value: PropTypes.any,
  customOptionRender: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func,
};

export default Dropdown;
